import axios from "axios";
import Api from "../Api";

const Service = {
  async get() {
    try {
      const data = {
        "PAGE": 0,
        "LIMIT": 10,
        "FIELDS": "*"
      }
      const response = await axios.post(`${Api}/api/GET_ALL_PERMISSION`,
        JSON.stringify(data),
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("Token")}`,
          },
        }
      );
      if (response.status === 200) {

        return { success: true, data: response.data };
      } else if (response.status === 403) {
        localStorage.clear();
        window.location.reload();
      }
    } catch (error) {
      return { success: false, error };
    }
  },

  async post(data, link) {
    try {
      const response = await axios.post(
        `${Api}/api/${link}`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("Token")}`,
          },
        }
      );
      console.log(response.status)
      if (response.status === 200) {
        return { success: true, data: response.data };
      }
    } catch (error) {
      return { success: false, error };
    }
  },


  async delete(id) {
    try {
      const data = {
        "id": id
      }

      console.log(data)
      const response = await axios.post(
        `${Api}/api/DELETES_PERMISSION_BY_ID`,
        JSON.stringify(data),
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("Token")}`,
          },
        }
      );
      if (response.status === 200) {
        return { success: true, data: response.data };
      }
    } catch (error) {
      return { success: false, error };
    }
  },
};

export default Service;
